export enum Commissioning {
    UNKNOWN = 'UNKNOWN',
    COMMISSIONED = 'COMMISSIONED',
    IN_PROGRESS = 'IN_PROGRESS'
}
